import isMobile from './isMobile';

export default function tooltip() {
  $(() => {
    $('[data-toggle="tooltip"]')
      .tooltip()
      .on('shown.bs.tooltip', () => {
        if (isMobile()) $('body').css('cursor', 'pointer');
      })
      .on('hide.bs.tooltip', () => {
        if (isMobile()) $('body').css('cursor', 'auto');
      });
  });
}



// WEBPACK FOOTER //
// ./client/app/common/utils/tooltip.js